var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.692,
    xmlns: "http://www.w3.org/2000/svg",
    height: 18.462,
    id: "screenshot-b686d946-cff2-8029-8008-0b6d6264619a",
    viewBox: "14104.654 2295.769 12.692 18.462",
    style: {
      WebkitPrintColorAdjust: ":exact"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-b686d946-cff2-8029-8008-0b6d6264619a",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-b686d946-cff2-8029-8008-0b6d6264619b"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-b686d946-cff2-8029-8008-0b6d6264619b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14104.6533203125,2313.0771484375L14107.408203125,2313.0771484375L14117.3466796875,2313.0771484375"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "strokes-ada39165-9095-80b3-8008-5dcae1bd5d47-b686d946-cff2-8029-8008-0b6d6264619b",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14104.6533203125,2313.0771484375L14107.408203125,2313.0771484375L14117.3466796875,2313.0771484375",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1,
      stroke: "#40ac83",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-b686d946-cff2-8029-8008-0b6d6264619c",
    style: {
      opacity: 0.9
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-b686d946-cff2-8029-8008-0b6d6264619c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14105.23046875,2306.154052734375L14111,2309.615234375L14116.76953125,2306.154052734375"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "strokes-ada39165-9095-80b3-8008-5dcae1bd8c7c-b686d946-cff2-8029-8008-0b6d6264619c",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14105.23046875,2306.154052734375L14111,2309.615234375L14116.76953125,2306.154052734375",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1,
      stroke: "#40ac83",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "shape-b686d946-cff2-8029-8008-0b6d6264ba54",
    style: {
      opacity: 0.9
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-b686d946-cff2-8029-8008-0b6d6264ba54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14110.994140625,2295.769287109375L14110.994140625,2309.615234375"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "strokes-ada39165-9095-80b3-8008-5dcae1bd8c7d-b686d946-cff2-8029-8008-0b6d6264ba54",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14110.994140625,2295.769287109375L14110.994140625,2309.615234375",
    style: {
      fill: "none",
      fillOpacity: "none",
      strokeWidth: 1,
      stroke: "#40ac83",
      strokeOpacity: 1
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.50eaded14b73ca1b7d610d23a0f9f1f6.svg";
export { ForwardRef as ReactComponent };